import { motion } from 'framer-motion';
import { filter } from 'lodash';

import { Icon } from '@/components/icon';
import { Text } from '@/components/text';
import { LoadingSpinner } from '@/components/ui/loading/spinner';
import { PortInterface } from '@/types';
import { tv } from '@/utils/styles';

interface Props {
  filteredPorts: PortInterface[];
  ports?: PortInterface[];
  isSearchingAllPorts?: boolean;
}

const PortsCountBox = ({ filteredPorts, ports, isSearchingAllPorts = false }: Props) => {
  const { base, countBox, items, divider, loadingSpinner, text, subText, icon } = styles();

  return (
    <div className={base()}>
      <LoadingSpinner isVisible={isSearchingAllPorts} size="2rem" className={loadingSpinner()} />
      <motion.div
        initial="hidden"
        animate={isSearchingAllPorts ? 'hidden' : 'visible'}
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1 },
        }}
        transition={{ ease: 'easeInOut', duration: 0.5, delay: 0.7 }}
      >
        <div className={items()}>
          <div className={countBox()}>
            <Icon name="plane" color="transport.plane" size="base" className={icon()} />
            <Text variant="sm" className={text()}>
              {filter(filteredPorts, { type: 'airport' }).length}{' '}
              {ports && <span className={subText()}>/ {filter(ports, { type: 'airport' }).length}</span>}
            </Text>
          </div>
          <span className={divider()} />
          <div className={countBox()}>
            <Icon name="ship" color="transport.ship" size="base" className={icon()} />
            <Text variant="sm" className={text()}>
              {filter(filteredPorts, { type: 'seaport' }).length}{' '}
              {ports && <span className={subText()}>/ {filter(ports, { type: 'seaport' }).length}</span>}
            </Text>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'ml-auto flex items-center',
    items: 'flex items-center',
    countBox: 'flex items-center whitespace-nowrap',
    divider: 'mx-3 block h-4 w-px bg-grey-200',
    loadingSpinner: 'left-[94%]',
    text: 'mb-0 text-sm font-semibold',
    subText: 'text-grey-400',
    icon: 'mr-2',
  },
});

export { PortsCountBox };
